import ActionCategory from 'app/enums/ActionCategory'

export default function(input){

    switch(input){

        case ActionCategory.NO_DATA: return 'Geen dataverzending';
        case ActionCategory.OFFLINE: return 'Logger offline';
        case ActionCategory.MOISTURE: return 'Water / vocht / condens';
        case ActionCategory.DEVIATION_EXCEEDED: return 'Afwijking laatste handmeting en loggermeting groter dan 5 centimeter. Controlemetingen uitvoeren';
        case ActionCategory.STRANGE_PROGRESS: return 'Vreemd verloop grondwaterstand, controlemetingen uitvoeren';
        case ActionCategory.SMALL_MAINTENANCE: return 'Klein onderhoud';
        case ActionCategory.PROVIDER_MALFUNCTION: return 'Provider storing';
        case ActionCategory.OTHER: return 'Anders (opmerkingenveld)';

        case ActionCategory.RESET: return 'Reset uitgevoerd';
        case ActionCategory.BATTERY: return 'Batterij vervangen';
        case ActionCategory.BOARD_CHANGE: return 'Printwissel uitgevoerd';
        case ActionCategory.REPLACE_LOGGER: return 'Logger vervangen';
        case ActionCategory.PHYSICAL_DAMAGE: return 'Fysieke beschadiging meetpunt';
        case ActionCategory.NOT_ACCESSIBLE: return 'Locatie niet toegankelijk (begroeiing, obstakel op straatpot etc)';
        case ActionCategory.CONTROL_MEASUREMENT: return 'Controlemeting uitgevoerd nav categorie kantoor)';
        case ActionCategory.BACK_ONLINE: return 'Vanzelf weer online gekomen';

        case ActionCategory.LOGGER_FUNCTIONAL: return 'Logger functioneert';
        case ActionCategory.SENSOR_DIRTY: return 'Sensor vuil';

        default: return '';
    }
}